// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TmAF","largestCol":"styles_largestCol__1K18w","smallestCol":"styles_smallestCol__bQceZ"};